<div class="event-item__container">
    <div class="event-item__wrapper d-flex flex-row">
        <div class="d-flex flex-row">
            <img class="img-fluid" src="{{event.pictureUrl}}" onerror="this.src='./assets/images/logo/Event-Cover-Placeholder.png'"  alt="event-cover">
            </div>
        <div class="event-item__info d-flex flex-column">
          <div class="container-fluid">
            <div class="row event-item__info__header">
              <div class="col-11 ps-0">
                <div class="text-break">
                  <h4>{{ event?.name }}</h4>
              </div>
              </div>
              <div class="col-1">
                <div class="d-flex flex-column rat-star align-items-center" *ngIf="event.status == 'Active'">
                  <mat-icon>star</mat-icon>
                  <span>{{event?.rate ? event?.rate:'0'}}</span>
                </div>
              </div>
            </div>
          </div>
            <div class="d-flex flex-row gap-3">
                <div style="width:212px;">
                  <div class="label">{{ 'EVENTS.DESCRIPTION' | translate }}</div>
                  <p class="block-with-text">{{ (event?.description.length>150)? (event?.description | slice:0:150)+'...':(event?.description) }}</p>
                </div>
                <div class="d-flex flex-column" style="width:182px;">
                    <div>
                      <div class="label">{{ 'EVENTS.DATE' | translate }}</div>
                      <p class="date-time">{{event?.startDateTime}}</p>
                    </div>
                    <div>
                      <div class="label">{{ 'EVENTS.TIME' | translate }}</div>
                      <p class="date-time">{{event?.startTime}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="event-item__actions d-flex flex-row">
              <container-element [ngSwitch]="event?.status">
                <div *ngSwitchCase="'Active'">
                  <div class="d-flex flex-column">
                    <div class="label">{{ 'RESERVATIONS.RESERVATIONS' | translate }}</div>
                    <div class="event-item__actions__live d-flex flex-row gap-1">
                      <div>
                        <span class="sub-label">{{ 'RESERVATIONS.CONFIRMED' | translate }}</span>
                        <p class="content-md">{{event?.confirmed}}</p>
                      </div>
                      <div>
                        <span class="sub-label">{{ 'RESERVATIONS.AVAILABLE' | translate }}</span>
                        <p class="content-md">{{event?.available}}</p>
                      </div>
                      <div>
                        <span class="sub-label">{{ 'RESERVATIONS.EXPECTED' | translate }}</span>
                        <p class="content-md">{{event?.expected}}</p>
                      </div>
                    </div>
                    <div class="event-item__actions__live d-flex flex-row gap-1 mt-negative1">
                      <div>
                        <span class="sub-label">{{ 'RESERVATIONS.SEATED' | translate }}</span>
                        <p class="content-md">{{event?.seated}}</p>
                      </div>
                      <div>
                        <span class="sub-label accend">{{ 'RESERVATIONS.LATE' | translate }}</span>
                        <p class="content-md">{{event?.lateGuest}}</p>
                      </div>
                      <div>
                        <!-- <span class="sub-label accend">Hailing</span> -->
                        <!-- <p class="content-md">{{event?.lateGuest}}</p> -->
                      </div>
                    </div>
                    <div class="mtb-4-half"></div>
                  <!-- <div class="mtb-temp"></div> -->
                    <button class="btn btn-full" (click)="onManage(event?.id)">{{ 'EVENTS.MANAGE' | translate }}</button>
                  </div>
                </div>

                <div *ngSwitchCase="'Published'">
                  <div class="d-flex flex-column">
                    <div class="label">{{ 'RESERVATIONS.RESERVATIONS' | translate }}</div>
                    <div class="event-item__actions__published d-flex flex-row gap-1">
                      <div>
                        <span class="sub-label">{{ 'RESERVATIONS.CONFIRMED' | translate }}</span>
                        <p class="content-md">{{event?.confirmed}}</p>
                      </div>
                      <div>
                        <span class="sub-label">{{ 'RESERVATIONS.AVAILABLE' | translate }}</span>
                        <p class="content-md">{{event?.available}}</p>
                      </div>
                      <div>
                        <span class="sub-label accend">{{ 'RESERVATIONS.PENDING' | translate }}</span>
                        <p class="content-md">{{event?.pending}}</p>
                      </div>
                    </div>
                    <div class="mtb-4"></div>
                    <div *ngIf="loadingPage" class="row">
                      <div class="col-12">
                        <mat-spinner class="api-data-spinner"></mat-spinner>
                      </div>
                    </div>
                    <div *ngIf="!loadingPage">
                      <button class="btn btn-full" (click)="onManage(event?.id)">{{ 'EVENTS.MANAGE' | translate }}</button>
                      <button class="btn btn-gradient-border" (click)="onCancel(event?.id)">{{ 'CANCEL' | translate }}</button>
                    </div>
                  </div>
                </div>

                <div *ngSwitchCase="'Created'">
                  <div *ngIf="loadingPage" class="row mt-5">
                    <div class="col-12">
                      <mat-spinner class="api-data-spinner"></mat-spinner>
                    </div>
                  </div>
                    <div *ngIf="!loadingPage" class="row">
                      <div class="col-12">
                        <button class="btn btn-full" (click)="onPublish(event?.id)">{{ 'PUBLISH' | translate }}</button>
                      </div>
                      <div class="mtb-5"></div>
                      <div class="col-12">
                        <button class="btn btn-full" (click)="onManage(event?.id)">{{ 'EDIT' | translate }}</button>
                      </div>
                      <div class="col-12">
                        <button class="btn btn-gradient-border" (click)="onDelete(event?.id)">{{ 'DELETE' | translate }}</button>
                      </div>
                    </div>
                </div>

                <div *ngSwitchCase="'Finished'">
                  <div class="d-flex flex-column">
                    <div class="label d-flex flex-row justify-content-between">
                        <div>{{ 'EVENTS.RATING' | translate }}</div>
                        <div class="d-flex justify-content-end"><span class="primary">{{ 'DETAILS' | translate }}</span><mat-icon>star</mat-icon></div>
                    </div>
                    <div>
                      <app-rating [rate]="event.rate" [numberOfReviews]="event.numberOfReviews"></app-rating>
                    </div>
                    <div *ngIf="loadingPage" class="row mt-4">
                      <div class="col-12">
                        <mat-spinner class="api-data-spinner"></mat-spinner>
                      </div>
                    </div>
                    <div *ngIf="!loadingPage" class="mtb-6">
                      <button class="btn btn-full" (click)="onOpen(event?.id)">{{ 'OPEN' | translate }}</button>
                      <button class="btn btn-gradient-border" (click)="onDelete(event?.id)">{{ 'DELETE' | translate }}</button>
                    </div>
                  </div>
                </div>

                <!--default case when there are no matches -->
                <div *ngSwitchDefault>...</div>
              </container-element>
        </div>
    </div>
</div>
